import { memo } from 'react';

import { Badge, Flex, Heading, Text } from '@/components/core';
import { ExportHeader, SetupRequired } from '@/components/flow';
import { ExcelLogo } from '@/components/logos';
import { toActionId, useGetAction } from '@/hooks/api';
import { isNotConfiguredExport } from '@/utils';

export type ExcelExportNodeContentProps = {
  agentId: string;
  actionId: string;
};

const IExcelExportNodeContent = ({ agentId, actionId }: ExcelExportNodeContentProps) => {
  const { data: action } = useGetAction(toActionId(actionId));

  return (
    <>
      <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
        <ExportHeader agentId={agentId} actionId={actionId}>
          <ExcelLogo size="lg" />
          <Heading size="lg">Export to Excel</Heading>
        </ExportHeader>
      </div>
      <div className="flex gap-2 pt-2">
        {isNotConfiguredExport(action) ? (
          <SetupRequired />
        ) : (
          <Flex className="gap-sm items-center">
            <Text>Export files to</Text>
            <Badge variant="plain">
              <Text>Excel</Text>
            </Badge>
          </Flex>
        )}
      </div>
    </>
  );
};

export const ExcelExportNodeContent = memo(IExcelExportNodeContent) as typeof IExcelExportNodeContent;
